import { format } from 'date-fns';
import { dateFnsLocales } from './getDateFnsLocales';

export const isClockTime = (code) => ["{clock time}", "{clock_time}"].includes(code)

export const addUnitDetails = (display, code) => isClockTime(code) ? `${display} (minutes since midnight)` : display

export const formatClockTimeValue = (minutesSinceMidnight, locale = 'en') => {
  if (minutesSinceMidnight == null || minutesSinceMidnight === '') {
    return null;
  }

  let minutes = minutesSinceMidnight;
  if (typeof minutes === 'string') {
    minutes = Number(minutes);
  }

  if (isNaN(minutes) || minutes < 0 || minutes >= 1440) {
    return null;
  }

  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;

  const date = new Date();
  date.setHours(hours, mins, 0, 0);

  return format(date, 'p', {
    locale: dateFnsLocales[locale],
  });
}

export const validateNumericRange = (value, minValue, maxValue) => {
  if (value === null || value === undefined || value === '') {
    return false;
  }

  const numValue = parseFloat(value);
  if (isNaN(numValue)) {
    return false;
  }

  // Check min if defined (including 0)
  if ((minValue || minValue === 0) && numValue < parseFloat(minValue)) {
    return false;
  }

  // Check max if defined (including 0)
  if ((maxValue || maxValue === 0) && numValue > parseFloat(maxValue)) {
    return false;
  }

  return true;
}